<div class="card collapse-icon accordion-icon-rotate" style="margin-bottom: 1rem">
  <div
    id="dependenteColapsed"
    class="card-header collapse-format"
    [ngClass]="erroMessageDependente == false ? 'border-info' : 'border-danger'">
    <a
      data-toggle="collapse"
      href="#dependent"
      aria-expanded="false"
      aria-controls="dependent"
      class="card-title lead info"
      [ngClass]="erroMessageDependente == false ? 'info' : 'danger'">
      <i class="ft-users" aria-hidden="true"></i>
      Dados do Dependente
      <i
        style="color: red"
        *ngIf="erroMessageDependente"
        placement="top"
        ngbTooltip="Verifique os campos obrigatórios."
        class="cursor-pointer fa fa-exclamation-triangle"
        aria-hidden="true"></i>
    </a>
  </div>
  <div
    id="dependent"
    role="tabpanel"
    aria-labelledby="dependenteColapsed"
    class="card-collapse collapse"
    aria-expanded="false">
    <div class="card-content">
      <div class="card-body espacamento-form-mobile">
        <!-- Botão Adicionar Dependente -->
        <div
          *ngIf="!somenteLeitura && !somenteLeituraColaboradorBeneficiario"
          class="float-right mb-1 mt-1 col-12 area-btn-add-dependente-mobile">
          <button
            *ngIf="showBtnAdd"
            (click)="onShowformDependente()"
            id="btnAdd"
            type="button"
            class="btn-add-dependente-mobile btn cursor-pointer btn-round bg-side-bar-geia white btn-min-width box-shadow-4 mr-1 mb-1 float-right">
            <i class="ft-plus white"></i>
            Adicionar Dependente
          </button>
        </div>
        <!-- Formulário -->
        <form [formGroup]="formularioDependente" *ngIf="showFormDependente">
          <div class="col-12">
            <!-- Banner de ALERTA CASAMENTO -->
            <div
              *ngIf="formularioDependente.get('weddingDate')?.hasError('dataCasamentoInvalida')"
              class="alert alert-shake row mt-3 justify-content-center align-items-center col-md-12 round alert-icon-left alert-arrow-left alert-warning alert-dismissible mb-2"
              role="alert">
              <span class="alert-icon"><i class="fa fa-1x fa-exclamation"></i></span>

              <h4 class="text-bold-500 text-center mb-1">
                <h3>
                  <p>Casamento acima de 30 dias.</p>
                  <p class="mt-1">
                    O tipo
                    <b>Inclusão de Recém-casado</b>
                    pode não se aplicar sem carências. Considere
                    <b>Inclusão com carências.</b>
                  </p>
                </h3>
              </h4>
            </div>
            <!-- Banner de urgência para IRN -->
            <div
              *ngIf="recenNascidoInvalido"
              class="alert alert-shake row mt-3 justify-content-center align-items-center col-md-12 round alert-icon-left alert-arrow-left alert-warning alert-dismissible mb-2"
              role="alert">
              <span class="alert-icon"><i class="fa fa-1x fa-exclamation"></i></span>

              <h4 class="text-bold-500">
                <h3>
                  {{ mensagemBannerUrgente }}
                </h3>
              </h4>
            </div>
            <div class="form-group row">
              <!-- Nome -->
              <div class="form-group mb-1 col-md-8 col-sm-12">
                <label for="nameDependente">Nome Completo</label>
                <input
                  (ngModelChange)="onFieldChange()"
                  type="text"
                  class="form-control round"
                  id="name"
                  maxlength="250"
                  formControlName="name"
                  [ngClass]="{
                    'is-invalid': formularioDependente.controls['name'].errors && isFormSubmited
                  }" />
                <app-validacao-form-input
                  [nomeFormulario]="formularioDependente"
                  nomeCampo="name"
                  [maxLength]="250"
                  [minLength]="10"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                <div
                  class="errorsName"
                  *ngIf="
                    formularioDependente.get('name')?.invalid &&
                    (formularioDependente.get('name')?.touched || formularioDependente.get('name')?.dirty)
                  ">
                  <div class="errorsName" *ngIf="formularioDependente.get('name')?.hasError('checkName')">
                    {{ formularioDependente.get('name')?.errors?.['checkName'] }}
                  </div>
                </div>
              </div>
              <!-- Tipo de proposta -->
              <div class="form-group col-sm-12 col-md-4">
                <label for="proposalType">Tipo de Proposta</label>
                <ng-select
                  (change)="onTipoPropostaChange($event)"
                  id="proposalType"
                  class="round shadow"
                  [multiple]="false"
                  [loading]="false"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  formControlName="proposalType"
                  [ngClass]="{'somente-leitura': somenteLeitura}"
                  notFoundText="Nenhum registro localizado">
                  <ng-option *ngFor="let option of listaEnumTipoPropostaDependente" [value]="option.value">
                    {{ option.description }}
                  </ng-option>
                </ng-select>

                <app-validacao-form-input
                  [nomeFormulario]="formularioDependente"
                  nomeCampo="proposalType"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              </div>
              <!-- Parentesco -->
              <div class="form-group mb-1 col-sm-12 col-md-4">
                <label for="branchCompanyContractKinshipId">Parentesco</label>
                <ng-select
                  (ngModelChange)="onFieldChange()"
                  [multiple]="false"
                  [loading]="false"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  class="round shadow"
                  [ngClass]="{'somente-leitura': somenteLeitura}"
                  formControlName="branchCompanyContractKinshipId">
                  <ng-option *ngFor="let grau of listarGrauParentesco" [value]="grau.id">
                    {{ grau.name }}
                  </ng-option>
                </ng-select>
              </div>
              <!-- CPF -->
              <div class="form-group mb-1 col-sm-12 col-md-4">
                <label for="cpf">CPF</label>
                <input
                  name="cpf"
                  (ngModelChange)="onFieldChange()"
                  [showMaskTyped]="true"
                  mask="000.000.000-99"
                  formControlName="cpf"
                  class="form-control border-radius"
                  [ngClass]="{
                    'is-invalid': formularioDependente.controls['cpf'].errors && isFormSubmited
                  }"
                  id="cpf" />
                <app-validacao-form-input
                  [nomeFormulario]="formularioDependente"
                  nomeCampo="cpf"
                  [maxLength]="250"
                  [minLength]="10"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              </div>
              <!-- Estado Civil -->
              <div class="form-group col-md-4 col-sm-12">
                <label for="civilStatusId">Estado Civil</label>
                <ng-select
                  (ngModelChange)="onFieldChange()"
                  [multiple]="false"
                  [loading]="false"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  class="round shadow"
                  formControlName="civilStatusId"
                  [ngClass]="{
                    'campo-obrigatorio': formularioDependente.controls['civilStatusId'].errors && isFormSubmited
                  }"
                  notFoundText="Nenhum registro localizado">
                  <ng-option *ngFor="let estadoCivil of listaEstatusCivil" [value]="estadoCivil.id">
                    {{ estadoCivil.name }}
                  </ng-option>
                </ng-select>
                <app-validacao-form-input
                  [nomeFormulario]="formularioDependente"
                  nomeCampo="civilStatusId"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              </div>
              <!-- CNS -->
              <div class="form-group mb-1 col-sm-12 col-md-4">
                <ng-template #faqTemplateCNS>
                  <app-faqs [fieldName]="'CNS'"></app-faqs>
                </ng-template>
                <label for="cns">
                  CNS
                  <a
                    href="https://cnesadm.datasus.gov.br/cnesadm/publico/usuarios/cadastro"
                    target="_blank"
                    class="input-icon">
                    <i placement="top" aria-hidden="true" class="fa fa fa-exclamation-circle"></i>
                  </a>
                </label>
                <input
                  [ngClass]="{
                    'is-invalid': formularioDependente.controls['cns'].errors && isFormSubmited
                  }"
                  mask="000 0000 0000 0000"
                  (ngModelChange)="onFieldChange()"
                  [showMaskTyped]="true"
                  type="text"
                  class="form-control round"
                  id="cns"
                  formControlName="cns" />
                <app-validacao-form-input
                  [nomeFormulario]="formularioDependente"
                  nomeCampo="cns"
                  [maxLength]="250"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              </div>
              <!-- Nome da Mãe -->
              <div class="form-group mb-1 col-sm-12 col-md-8">
                <label for="mothersName">Nome da Mãe</label>
                <input
                  (ngModelChange)="onFieldChange()"
                  type="text"
                  class="form-control round"
                  id="mothersName"
                  maxlength="250"
                  [ngClass]="{
                    'is-invalid': formularioDependente.controls['mothersName'].errors && isFormSubmited
                  }"
                  formControlName="mothersName" />
                <app-validacao-form-input
                  [nomeFormulario]="formularioDependente"
                  nomeCampo="mothersName"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                <div
                  class="errorsName"
                  *ngIf="
                    formularioDependente.get('mothersName')?.invalid &&
                    (formularioDependente.get('mothersName')?.touched || formularioDependente.get('mothersName')?.dirty)
                  ">
                  <div class="errorsName" *ngIf="formularioDependente.get('mothersName')?.hasError('checkName')">
                    {{ formularioDependente.get('mothersName')?.errors?.['checkName'] }}
                  </div>
                </div>
              </div>
              <!-- Sexo -->
              <div class="form-group mb-1 col-sm-12 col-md-4">
                <label for="sex">Sexo</label>
                <br />
                <label style="margin-right: 50px" [ngClass]="{'cursor-desabilitado': somenteLeitura}">
                  <input
                    (ngModelChange)="onFieldChange()"
                    formControlName="sex"
                    value="1"
                    id="active"
                    type="radio"
                    class="input-radio off"
                    name="sex"
                    checked
                    [ngClass]="{'cursor-desabilitado': somenteLeitura}" />
                  Masculino
                </label>
                <label [ngClass]="{'cursor-desabilitado': somenteLeitura}">
                  <input
                    (ngModelChange)="onFieldChange()"
                    formControlName="sex"
                    value="2"
                    id="Inactive"
                    type="radio"
                    class="input-radio on"
                    name="sex"
                    [ngClass]="{'cursor-desabilitado': somenteLeitura}" />
                  Feminino
                </label>
                <app-validacao-form-input
                  [nomeFormulario]="formularioDependente"
                  nomeCampo="sex"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              </div>
              <div class="form-group" *ngIf="mostrarDataCasamento">
                <label for="weddingDate">Data do Casamento</label>
                <div class="input-group">
                  <input
                    #weddingDatePicker="bsDatepicker"
                    bsDatepicker
                    name="weddingDate"
                    type="text"
                    class="form-control round"
                    id="weddingDate"
                    [minDate]="minWeddingDate"
                    [maxDate]="maxWeddingDate"
                    [bsConfig]="bsConfig"
                    formControlName="weddingDate"
                    (ngModelChange)="validarDataCasamento($event)"
                    (blur)="validarDataCasamento($event)"
                    [ngClass]="{'is-invalid': dataCasamentoInvalida}" />

                  <div *ngIf="!ehVisualizar" class="input-group-append">
                    <button
                      class="btn btn-secondary round botao-calendario"
                      type="button"
                      (click)="weddingDatePicker.show()">
                      <i class="fa fa-calendar"></i>
                    </button>
                  </div>
                </div>
                <app-validacao-form-input
                  [nomeFormulario]="formularioDependente"
                  nomeCampo="weddingDate"
                  [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                <div *ngIf="dataCasamentoInvalida" class="text-danger">
                  A data do casamento não pode ser superior a 30 dias.
                </div>
              </div>
              <!-- Data de Nascimento -->
              <div class="col-12 col-sm-12 col-md-3 mb-2 tamanho-campo-medio-formulario-tablet">
                <label for="birthDate">Data de Nascimento</label>
                <input
                  *ngIf="somenteLeitura; else ehBeneficiario"
                  #datepicker="bsDatepicker"
                  bsDatepicker
                  name="birthDate"
                  maxlength="10"
                  type="text"
                  class="form-control round somente-leitura"
                  id="birthDate"
                  formControlName="birthDate"
                  readonly />
                <ng-template #ehBeneficiario>
                  <div class="input-group">
                    <input
                      #datepicker="bsDatepicker"
                      bsDatepicker
                      name="birthDate"
                      maxlength="10"
                      type="text"
                      class="form-control round bg-white"
                      id="birthDate"
                      [minDate]="minDate"
                      [maxDate]="maxDate"
                      [bsConfig]="bsConfig"
                      (bsValueChange)="atualizarValorPorIdadeDependente()"
                      formControlName="birthDate"
                      [ngClass]="{
                        'is-invalid': formularioDependente.controls['birthDate'].errors && isFormSubmited
                      }"
                      (focus)="campoDataSelecionado($event)"
                      (ngModelChange)="
                        formatarCampoData($event, 'birthDate'); validarDataNascimentoRecenNascido($event)
                      "
                      (onShown)="esconderCalendario()" />

                    <div class="input-group-append">
                      <button
                        style="border-bottom-right-radius: 20px; border-top-right-radius: 20px"
                        class="btn round btn-secondary botao-calendario"
                        type="button"
                        (click)="mostrarCalendario()">
                        <i class="fa fa-calendar"></i>
                      </button>
                    </div>

                    <!-- Mensagem de erro para recém-nascido inválido -->
                    <div *ngIf="recenNascidoInvalido" class="text-danger">
                      Para inclusão de recém-nascido, a data de nascimento não pode ser superior a 30 dias.
                    </div>
                    <app-validacao-form-input
                      [nomeFormulario]="formularioDependente"
                      nomeCampo="birthDate"
                      [maxLength]="16"
                      [minLength]="10"
                      [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                  </div>
                </ng-template>
              </div>
              <!-- Idade -->
              <div class="form-group col-md-2 col-sm-12">
                <label for="age">Idade</label>
                <input
                  type="number"
                  (ngModelChange)="emitirIdade($event)"
                  formControlName="age"
                  class="round form-control somente-leitura"
                  id="age"
                  readonly="true" />
              </div>

              <ng-container *ngIf="!heOdonto">
                <h4 class="form-section col-sm-12 col-md-12 mt-2">
                  <i class="fa fa-address-book"></i>
                  Dados da Operadora e Atendimento - Dependente
                </h4>
                <!-- Formulário de Análise da Operadora Anterior -->
                <div class="col-md-12">
                  <div class="row">
                    <!-- Operadora Anterior -->
                    <div class="form-group mb-1 col-sm-12 col-md-8 tamanho-campo-grande-formulario-tablet">
                      <label for="previousOperator">Operadora Anterior</label>
                      <input
                        maxlength="250"
                        [ngClass]="{
                          'is-invalid':
                            formularioDependente.get('previousOperator')?.invalid &&
                            (formularioDependente.get('previousOperator')?.touched || isFormSubmited)
                        }"
                        (ngModelChange)="onFieldChange()"
                        type="text"
                        class="form-control round"
                        id="previousOperator"
                        formControlName="previousOperator" />
                      <app-validacao-form-input
                        [nomeFormulario]="formularioDependente"
                        nomeCampo="previousOperator"
                        [maxLength]="250"
                        [isFormSubmited]="isFormSubmited"
                        [campoTocado]="
                          !!formularioDependente?.get('previousOperator')?.touched
                        "></app-validacao-form-input>
                    </div>
                    <!-- Tempo de Permanência -->
                    <div class="form-group mb-1 col-sm-12 col-md-4 tamanho-campo-medio-formulario-tablet">
                      <label for="dwellTime">Tempo de Permanência</label>
                      <input
                        (ngModelChange)="onFieldChange()"
                        type="number"
                        class="form-control round"
                        id="dwellTime"
                        formControlName="dwellTime"
                        [ngClass]="{
                          'is-invalid':
                            formularioDependente.get('dwellTime')?.invalid &&
                            (formularioDependente.get('dwellTime')?.touched || isFormSubmited)
                        }"
                        min="0"
                        oninput="
                          this.value = Math.min(parseInt(this.value))
                            .toString()
                            .replace(/[^0-9]/g, '')
                        " />
                      <app-validacao-form-input
                        [nomeFormulario]="formularioDependente"
                        nomeCampo="dwellTime"
                        [maxLength]="250"
                        [isFormSubmited]="isFormSubmited"
                        [campoTocado]="!!formularioDependente?.get('dwellTime')?.touched"></app-validacao-form-input>
                    </div>
                    <!-- Estado -->
                    <div class="form-group col-sm-12 col-md-4 tamanho-campo-medio-formulario-tablet">
                      <label for="stateId">Estado</label>
                      <ng-select
                        [multiple]="false"
                        [loading]="false"
                        [closeOnSelect]="true"
                        [searchable]="true"
                        notFoundText="Nenhum registro localizado"
                        [ngClass]="{
                          'campo-obrigatorio':
                            formularioDependente.get('stateId')?.invalid &&
                            (formularioDependente.get('stateId')?.touched || isFormSubmited)
                        }"
                        (change)="onChangeState($event)"
                        class="round shadow"
                        formControlName="stateId">
                        <ng-option *ngFor="let estado of listaEstados" value="{{ estado.id }}">
                          {{ estado.name }}
                        </ng-option>
                      </ng-select>
                      <app-validacao-form-input
                        [nomeFormulario]="formularioDependente"
                        nomeCampo="stateId"
                        [maxLength]="250"
                        [isFormSubmited]="isFormSubmited"
                        [campoTocado]="!!formularioDependente?.get('stateId')?.touched"></app-validacao-form-input>
                    </div>
                    <!-- Cidade -->
                    <div class="form-group col-sm-12 col-md-4 tamanho-campo-medio-formulario-tablet">
                      <label for="cityId ">Cidade</label>
                      <ng-select
                        [multiple]="false"
                        [loading]="false"
                        [closeOnSelect]="true"
                        [searchable]="true"
                        notFoundText="Nenhum registro localizado"
                        [ngClass]="{
                          'campo-obrigatorio':
                            formularioDependente.get('cityId')?.invalid &&
                            (formularioDependente.get('cityId')?.touched || isFormSubmited)
                        }"
                        class="round shadow"
                        formControlName="cityId">
                        <ng-option *ngFor="let cidade of listaCidades" value="{{ cidade.id }}">
                          {{ cidade.name }}
                        </ng-option>
                      </ng-select>
                      <app-validacao-form-input
                        [nomeFormulario]="formularioDependente"
                        nomeCampo="cityId"
                        [maxLength]="250"
                        [isFormSubmited]="isFormSubmited"
                        [campoTocado]="!!formularioDependente?.get('cityId')?.touched"></app-validacao-form-input>
                    </div>
                    <!-- <ng-container *ngIf="analiseOperadoraAnterior">
                      <div class="input-group mb-3 col-sm-12 col-md-6">
                        <label for="cat">Carta de Tempo de Permanência</label>
                        <br />
                        <div class="input-group mb-2">
                          <input
                            *ngIf="
                              !mostrarBtnSubstituirArquivoCPT &&
                              (!temDocumentoCTPExistente() || mostrarInputUploadCTP || novoArquivoCTPSelecionado)
                            "
                            placeholder="Selecione um arquivo para upload"
                            type="file"
                            class="form-control round"
                            id="fileCTP"
                            accept=".pdf,.jpg,.jpeg,.png"
                            (change)="onFileCTPSelected($event)" />

                          <div *ngIf="mostrarInputUploadCTP" class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-inputs btn-secondary round"
                              (click)="cancelarUploadCTP()">
                              <i class="fa fa-times"></i>
                              Cancelar
                            </button>
                          </div>
                          <div *ngIf="mostrarBtnSubstituirArquivoCPT && !temDocumentoCTPExistente()">
                            <button
                              type="button"
                              class="btn btn-warning round btn-inputs ml-1"
                              (click)="substituirArquivoCPT()">
                              <i class="fa fa-upload"></i>
                              Substituir
                            </button>
                          </div>
                        </div>
                        <div *ngIf="temDocumentoCTPExistente() && !novoArquivoCTPSelecionado" class="input-group mt-1">
                          <input
                            type="text"
                            class="form-control round"
                            [value]="getNomeArquivoCTP()"
                            readonly
                            placeholder="Arquivo atual" />
                          <div class="input-group-append mb-1">
                            <button type="button" class="btn btn-success btn-inputs" (click)="baixarDocumentoCTP()">
                              <i class="fa fa-download"></i>
                              Baixar
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="input-group mb-3 col-sm-12 col-md-6">
                        <label for="carta2">Documento de Adimplância do Plano de Origem</label>
                        <br />

                        <div class="input-group mb-2">
                          <input
                            *ngIf="
                              !mostrarBtnSubstituirArquivoDAPO &&
                              (!temDocumentoDAPOExistente() || mostrarInputUploadDAPO || novoArquivoDAPOSelecionado)
                            "
                            placeholder="Selecione um arquivo para upload"
                            type="file"
                            class="form-control round"
                            id="fileDAPO"
                            accept=".pdf,.jpg,.jpeg,.png"
                            (change)="onFileDAPOSelected($event)" />
                          <div *ngIf="mostrarInputUploadDAPO" class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-secondary btn-inputs round"
                              (click)="cancelarUploadDAPO()">
                              <i class="fa fa-times"></i>
                              Cancelar
                            </button>
                          </div>
                          <div *ngIf="mostrarBtnSubstituirArquivoDAPO && !temDocumentoDAPOExistente()">
                            <button
                              type="button"
                              class="run btn btn-warning btn-inputs round ml-1"
                              (click)="substituirArquivoDAPO()">
                              <i class="fa fa-upload"></i>
                              Substituir
                            </button>
                          </div>
                        </div>

                        <div
                          *ngIf="temDocumentoDAPOExistente() && !novoArquivoDAPOSelecionado"
                          class="input-group mt-1">
                          <input
                            type="text"
                            class="form-control round mb-1"
                            [value]="getNomeArquivoDAPO()"
                            readonly
                            placeholder="Arquivo atual" />
                          <div class="input-group-append mb-1">
                            <button type="button" class="btn btn-success btn-inputs" (click)="baixarDocumentoDAPO()">
                              <i class="fa fa-download"></i>
                              Baixar
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-container> -->
                  </div>
                </div>

                <div class="form-group mb-1 mt-2 col-sm-12 col-md-12">
                  <label
                    [style.cursor]="radioButtonReducaoCarenciaSomenteLeitura() ? 'not-allowed' : 'pointer'"
                    [style.opacity]="radioButtonReducaoCarenciaSomenteLeitura() ? '0.6' : '1'"
                    (click)="radioButtonReducaoCarenciaSomenteLeitura() ? $event.preventDefault() : null">
                    <input
                      (change)="inserirDadosAntigaOperadora(true)"
                      (ngModelChange)="onFieldChange()"
                      formControlName="analysisPeriodReductionCheck"
                      [value]="true"
                      id="active"
                      type="radio"
                      class="input-radio on"
                      name="analysisPeriodReductionCheck"
                      [attr.disabled]="radioButtonReducaoCarenciaSomenteLeitura() ? 'disabled' : null" />

                    &nbsp;&nbsp; Desejo submeter-me a Análise Técnica de Redução de Carências e declaro ter conhecimento
                    de que a análise atenderá a critérios técnicos internos da administradora, que tem a faculdade de
                    conceder ou não a redução de carências. (Neste caso, deverá ser preenchido o formulário posterior).
                  </label>
                  <label>
                    <input
                      checked
                      (change)="inserirDadosAntigaOperadora(false)"
                      (ngModelChange)="onFieldChange()"
                      formControlName="analysisPeriodReductionCheck"
                      [value]="false"
                      id="Inactive"
                      type="radio"
                      class="input-radio off"
                      name="analysisPeriodReductionCheck" />
                    &nbsp;&nbsp; Dispenso a Análise Técnica de Redução de Carências e declaro estar ciente de que ao
                    aderir ao plano de saúde, as coberturas contratuais estarão condicionadas ao cumprimento dos
                    períodos de carência informados no Quadro 1 acima.
                  </label>
                  <app-validacao-form-input
                    [nomeFormulario]="formularioDependente"
                    nomeCampo="analysisPeriodReductionCheck"
                    [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
                </div>
              </ng-container>

              <div
                *ngIf="mostrarMensagemPortabilidadeSumula"
                class="alert alert-shake row mt-3 lert-dismissible justify-content-center align-items-center col-md-12 round alert-icon-left alert-arrow-left alert-warning alert-dismissible mb-2"
                role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <span class="alert-icon"><i class="fa fa-exclamation-circle"></i></span>

                <h4 class="text-bold-500">
                  <h3 [innerHTML]="mensagemAlertaSumulaPortabilidade"></h3>
                </h4>
              </div>
            </div>
          </div>
        </form>
        <!-- Tabela -->
        <div class="float-right" *ngIf="showFormDependente">
          <ng-container *ngIf="!somenteLeitura || somenteLeituraColaboradorBeneficiario">
            <button
              (click)="adicionarOuAtualizarDependente()"
              class="btn btn-success btn-round btn-format float-right btn-min-width box-shadow-4 mr-2 mb-1"
              type="button">
              <i [ngClass]="editingIndex > -1 ? 'ft-refresh-cw' : 'ft-plus'"></i>
              {{ editingIndex > -1 ? ' Atualizar' : ' Adicionar' }}
            </button>
            <button
              *ngIf="!somenteLeituraColaboradorBeneficiario"
              (click)="limparFormulario(); editingIndex = -1"
              class="btn btn-warning btn-round btn-format float-right btn-min-width box-shadow-4 mr-2 mb-1"
              type="button">
              <i class="ft-trash"></i>
              Limpar
            </button>
          </ng-container>
          <button
            (click)="onCancelar(); editingIndex = -1"
            type="button"
            id="btnCancelar"
            class="btn btn-round cursor-pointer float-right btn-geia-info btn-outline-info btn-min-width box-shadow-4 btn-format mr-2 mb-1">
            <i class="ft-x"></i>
            Cancelar
          </button>
        </div>

        <div class="table-responsive" style="float: left">
          <table class="table table is-responsive table-bordered">
            <thead class="bg-table-geia white">
              <tr>
                <th class="text-center">Nome</th>
                <th class="text-center">Data de Nascimento</th>
                <th class="text-center">Idade</th>
                <th class="text-center">Ações</th>
              </tr>
            </thead>
            <tr *ngFor="let itemDependente of listaDependentes; let i = index">
              <td>
                <span ngbTooltip="{{ itemDependente.name }}" tooltipClass="tooltip">
                  {{ itemDependente.name }}
                </span>
              </td>
              <td class="text-center">
                <span>
                  {{ itemDependente.birthDate | date: 'dd/MM/yyyy' }}
                </span>
              </td>
              <td class="text-center">
                {{ calcularIdadePessoa(itemDependente.birthDate) }}
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button (click)="onEdit(i)" class="btn btn-round box-shadow-4 btn-warning">
                    <i class="ft-edit darken-2"></i>
                  </button>
                  <button
                    *ngIf="!somenteLeitura && !somenteLeituraColaboradorBeneficiario"
                    class="btn btn-round box-shadow-4 btn-danger"
                    (click)="onRemove(i)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </table>
          <div class="row">
            <div class="col-sm-12 col-md-5">
              <div class="dataTables_info" role="status" aria-live="polite">
                Total de {{ listaDependentes.length }} Dependentes
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
